import React from "react";
import { ApolloProvider } from "@apollo/client";
import { AppProvider } from "../context/AppContext";
import { client } from "./client";
import { LanguageProvider } from "../context/LanguageContext";

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <AppProvider>
      <LanguageProvider>{element}</LanguageProvider>
    </AppProvider>
  </ApolloProvider>
);
